import React from 'react';

/* ─── Role icons (SVGs from ALL_NAV_ITEMS) ─── */
const CareIcon = (props) => (
  <svg width={props.size || 20} height={props.size || 20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
  </svg>
);
const CoordinatorIcon = (props) => (
  <svg width={props.size || 20} height={props.size || 20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="3"/>
    <circle cx="6" cy="12" r="3"/>
    <circle cx="18" cy="19" r="3"/>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
  </svg>
);

export const ROLE_CONFIG = [
  {
    id: 'care_coordinator',
    label: 'Care Coordinator',
    description: 'Consent, eligibility, alignment submission, device shipping, engagement, missed-reading triage, CMS reporting, monthly G-code claims',
    color: 'var(--wi-role-coordinator)',
    bgColor: '#F3F0FF',
    tint: 'var(--wi-role-coordinator-10)',
    Icon: CoordinatorIcon,
    taskRoles: ['care_coordinator', 'clinician', 'system'],
  },
  {
    id: 'clinician',
    label: 'Clinician',
    description: 'Care plan creation + validation, medical reviews, medication adjustments, lab interpretation, elevated-BP triage',
    color: 'var(--wi-status-good)',
    bgColor: 'var(--wi-background-good)',
    tint: 'var(--wi-status-good-10)',
    Icon: CareIcon,
    taskRoles: ['clinician', 'system'],
  },
];

export const ROLE_TABS = {
  care_coordinator: ['home', 'engage'],
  clinician:        ['home', 'engage'],
};

// Engage is a roster-wide comms surface, not task triage: every role sees the full 360° roster
// (care_coordinator scope), and the sidebar's unread badge counts that same roster.
export const ENGAGE_ROSTER_ROLE = 'care_coordinator';

/**
 * Normalize legacy role ids that may still be saved in localStorage from
 * earlier builds. Keeps existing user sessions working after the 2026-05-12
 * collapse to {care_coordinator, clinician}.
 *   md | rn | np | pharmacist | care_team    → clinician
 *   admin | operator | ops | operations      → care_coordinator
 */
export function normalizeRoleId(roleId) {
  if (!roleId) return roleId;
  if (roleId === 'md' || roleId === 'rn' || roleId === 'np' || roleId === 'pharmacist' || roleId === 'care_team') return 'clinician';
  if (roleId === 'admin' || roleId === 'operator' || roleId === 'ops' || roleId === 'operations') return 'care_coordinator';
  return roleId;
}

export function getRoleConfig(roleId) {
  return ROLE_CONFIG.find(r => r.id === roleId) || ROLE_CONFIG[0];
}

/**
 * `owner_role` values for the dashboard `task_roles` query param.
 * Returns the role's own task lane(s). The apiv2 dashboard view automatically
 * folds `system` into both role aggregates as a safety net so orchestrator-managed
 * tasks never become invisible — the fold is owned by apiv2's dashboard view PU.
 */
export function getDashboardTaskRoles(roleId) {
  if (!roleId) return null;
  const roles = getRoleConfig(roleId).taskRoles;
  return Array.isArray(roles) && roles.length > 0 ? [...roles] : null;
}
